var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value == 1)?_c('span',{staticClass:"badge bg-success"},[_vm._v(_vm._s(_vm.yesValue ? _vm.yesValue : _vm.translate.yes))]):_c('span',{staticClass:"badge bg-danger"},[_vm._v(_vm._s(_vm.noValue ? _vm.noValue : _vm.translate.not))])}
var staticRenderFns = []

export { render, staticRenderFns }